// extracted by mini-css-extract-plugin
export var changeIcon = "_3x-4";
export var container = "_3x-0";
export var divider = "_3x-7";
export var externalLinkIcon = "_3x-1";
export var green = "_3x-5";
export var helpCircleIcon = "_3x-3";
export var iconButton = "_3x-2";
export var red = "_3x-6";